import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { selectAccountChannelsSorted } from '~/store';
import customStyles from './customStyles';
import './UserSelectWithFilter.css';

const ChannelSelectWithFilter = ({ value, onChange, storageKey, filterAllValueStatus, placeholderText }) => {
  const accountChannels = useSelector(selectAccountChannelsSorted);

  const defaultOption = useMemo(
    () => ({ value: filterAllValueStatus, label: placeholderText }),
    [filterAllValueStatus, placeholderText]
  );

  const channelOptions = useMemo(
    () => [defaultOption, ...accountChannels.map(({ id, name }) => ({ value: id, label: name }))],
    [accountChannels, defaultOption]
  );

  const currentOption = useMemo(
    () => channelOptions.find(({ value: other }) => other === value) ?? defaultOption,
    [channelOptions, value, defaultOption]
  );

  const handleOptionChange = useCallback(
    (option) => {
      onChange(option.value || filterAllValueStatus);
    },
    [filterAllValueStatus, onChange]
  );

  useEffect(() => {
    sessionStorage.setItem(storageKey, value);
    localStorage.setItem(storageKey, value);
  }, [storageKey, value]);

  return (
    <div className="filter">
      <span className="byline filter-title">Channel: </span>
      <Select
        styles={customStyles}
        onChange={handleOptionChange}
        value={currentOption}
        placeholder={placeholderText}
        className="select-with-filter"
        isSearchable
        options={channelOptions}
      />
    </div>
  );
};

ChannelSelectWithFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  storageKey: PropTypes.string.isRequired,
  filterAllValueStatus: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
};

export default ChannelSelectWithFilter;
